// extracted by mini-css-extract-plugin
export default {"title":"Header_title__l+wMf","header":"Header_header__OKWO7"};